var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ais-Highlight ml-3",domProps:{"innerHTML":_vm._s(_vm.innerHtml)},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }